import axios from "axios";
// import { history } from "../App";
import { API_URL } from "../ConstVariable";

export default (history = null) => {
    let headers = {};
    const baseURL = API_URL;
    const token = localStorage.getItem("MyToken")
    if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

    const axiosInstance = axios.create({
        baseURL: baseURL,
        headers,
        withCredentials: true
    });

    const responseSuccessHandler = (response) => {
        return response;
    };

    const responseErrorHandler = (error) => {
        console.log(error)
        if (error.response) {
            if (error.response.status === 403 || error.response.status === 401) {
                localStorage.removeItem("token");
                if (history) {
                    history.push("/expired");
                } else {
                    window.location = "/expired";
                }
            }
        } else if (error.request) {
            console.error(error.request);
        } else {
            console.error("Error", error.message);
        }
        console.error(error.config);
        return Promise.reject(error);
    };

    axiosInstance.interceptors.response.use(
        (response) => responseSuccessHandler(response),
        (error) => responseErrorHandler(error)
    );

    return axiosInstance;
};
